var React = require('react');

function IconFolderDash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M165.807 54.754H146.6a6.04 6.04 0 0 0-6.033 6.033 6.04 6.04 0 0 0 6.033 6.034h13.173v10.553H41.226V44.136l34.025-.063 20.982 20.982a5.996 5.996 0 0 0 4.266 1.768h24.557a6.04 6.04 0 0 0 6.033-6.034 6.04 6.04 0 0 0-6.033-6.034h-22.058L82.013 33.768A6.005 6.005 0 0 0 77.734 32l-42.553.079a6.043 6.043 0 0 0-6.022 6.034v124.852a6.04 6.04 0 0 0 6.034 6.034h130.616a6.04 6.04 0 0 0 6.033-6.034V60.787a6.042 6.042 0 0 0-6.035-6.033zm-6.034 34.688v67.491H41.226V89.442h118.547z"}));
}

IconFolderDash.displayName = "IconFolderDash";

IconFolderDash.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = IconFolderDash;

IconFolderDash.default = IconFolderDash;
